import styled, { css } from 'styled-components';
export const BreezeCaretStyle = css(["position:relative;&::after{content:'';display:inline-block;width:8px;height:8px;border-radius:50%;background-color:#ff9fcc;animation:breezepulse 1s infinite;margin-left:8px;margin-right:8px;}@keyframes breezepulse{0%{transform:scale(1);background-color:#fbdbe9;}50%{transform:scale(1.3);background-color:#ff9fcc;}100%{transform:scale(1);background-color:#fbdbe9;}}"]);
export const BreezeLoadingDot = styled('div').attrs({
  role: 'loading',
  'data-loading': true
}).withConfig({
  displayName: "BreezeLoadingDot",
  componentId: "sc-1t8k3wb-0"
})(["", ""], BreezeCaretStyle);